// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import RentIncome from "./components/RentIncome/RentIncome";
// // import Trends from "../src/components/Trends/Trends"; // Assuming Trends is not used based on image
// import UpcomingRent from "./components/UpcomingRent/UpcomingRent";
// import Properties from "./components/Properties/Properties"; // Ensure Property.jsx exports default as Property, adjust if needed
// import Tenants from "./components/Tenants/Tenants";
// import CustomComponent from "./components/RecentPayments/CustomComponent-Original.jsx";
// import { paths } from "./Utility/Constants.js";
// import APICall from "./Utility/APICall.js";
// import { useAuth } from "./Utility/AuthProvider.js";
// // Removed unused imports like paths, APICall, useAuth if not directly used for layout logic here

// function Dashboard() {
//   const navigate = useNavigate();
//   const { jwt, user, isLoadingSession } = useAuth();

//   console.log("Dashboard user:-", user);

//   // Removed state (rentData, payments, loading, etc.) not directly needed for the layout structure itself.
//   // Keep them if Dashboard itself needs them for other logic, but the layout focuses on component placement.

//   const handleRecentPaymentClick = () => {
//     // navigate("/Payments");
//     navigate("/dashboard/payments");
//   };

//   const handleViewAllUpcomingRent = () => {
//     // Pass necessary state if Reports page needs it, e.g., via location state
//     // navigate("/Reports" /*, { state: { rentData } }*/);
//     navigate("/dashboard/reports");
//   };

//   const handleViewAllProperties = () => {
//     // navigate("/MyProperties");
//     navigate("/dashboard/my-properties");
//   };

//   const handleTenantsClick = () => {
//     // navigate("/MyProperties/TenantsList");
//     navigate("/dashboard/tenants-list");
//   };

//   return (
//     // Main container for the dashboard content with padding
//     <div className="p-4 md:p-6 lg:p-8 space-y-6 bg-gray-100 min-h-screen">
//       {" "}
//       {/* Added background and spacing */}
//       {/* Dashboard Header */}
//       <h1 className="text-2xl font-bold text-gray-800">Home</h1>{" "}
//       {/* Adjusted heading style */}
//       {/* Section 1: Rent Income (Full Width) */}
//       <section className="bg-white rounded-lg shadow-md p-4">
//         {/* Added container styling */}
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-lg font-semibold text-gray-700">Rent Income</h2>
//           <button
//             className="text-sm text-blue-600 hover:text-blue-800 font-medium"
//             // onClick={() => navigate("/CollectionsBuildingWise")}
//             onClick={() => navigate("/dashboard/collections-building-wise")}
//           >
//             View Insights
//           </button>
//         </div>
//         {/* RentIncome component already has its own internal layout */}
//         <RentIncome />
//       </section>
//       {/* Section 2: Recent Payments (Full Width) */}
//       <section className="bg-white rounded-lg shadow-md overflow-hidden">
//         {/* Added container styling, overflow hidden for table */}
//         {/* Header needs padding separate from the table */}
//         <div className="flex justify-between items-center p-4 border-b border-gray-200">
//           <h2 className="text-lg font-semibold text-gray-700">
//             Recent Payments
//           </h2>
//           <button
//             className="text-sm text-blue-600 hover:text-blue-800 font-medium"
//             onClick={handleRecentPaymentClick}
//           >
//             View All
//           </button>
//         </div>
//         {/* CustomComponent renders the table */}
//         {/* Add padding around the table content if CustomComponent doesn't */}
//         <div className="p-4">
//           {/* Add padding if needed */}
//           <CustomComponent displayAll={false} />
//         </div>
//       </section>
//       {/* Section 3: Upcoming Rent & Tenants (Two Columns) */}
//       {/* Using Flexbox for columns, responsive stacking */}
//       <section className="flex flex-col md:flex-row gap-6">
//         {/* Left Column: Upcoming Rent (Wider) */}
//         <div className="w-full md:w-2/3 bg-white rounded-lg shadow-md p-4">
//           {" "}
//           {/* Container styling */}
//           <div className="flex justify-between items-center mb-4">
//             <h2 className="text-lg font-semibold text-gray-700">
//               Upcoming Rent
//             </h2>
//             <button
//               className="text-sm text-blue-600 hover:text-blue-800 font-medium"
//               onClick={handleViewAllUpcomingRent}
//             >
//               View All
//             </button>
//           </div>
//           {/* UpcomingRent component */}
//           <UpcomingRent />
//         </div>

//         {/* Right Column: Tenants (Narrower) */}
//         <div className="w-full md:w-1/3 bg-white rounded-lg shadow-md p-4">
//           {" "}
//           {/* Container styling */}
//           <div className="flex justify-between items-center mb-4">
//             <h2 className="text-lg font-semibold text-gray-700">Tenants</h2>
//             <button
//               className="text-sm text-blue-600 hover:text-blue-800 font-medium"
//               onClick={handleTenantsClick}
//             >
//               View All
//             </button>
//           </div>
//           {/* Tenants component */}
//           <Tenants />
//         </div>
//       </section>
//       {/* Section 4: Properties (Full Width) */}
//       <section className="bg-white rounded-lg shadow-md p-4">
//         {" "}
//         {/* Added container styling */}
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-lg font-semibold text-gray-700">Properties</h2>
//           <button
//             className="text-sm text-blue-600 hover:text-blue-800 font-medium"
//             onClick={handleViewAllProperties}
//           >
//             View All
//           </button>
//         </div>
//         {/* Properties component */}
//         <Properties />
//       </section>
//     </div>
//   );
// }

// export default Dashboard;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RentIncome from "./components/RentIncome/RentIncome";
import UpcomingRent from "./components/UpcomingRent/UpcomingRent";
import Properties from "./components/Properties/Properties";
import Tenants from "./components/Tenants/Tenants";
import CustomComponent from "./components/RecentPayments/CustomComponent-Original.jsx";
import { useAuth } from "./Utility/AuthProvider.js";
import { useUnits } from "./Contexts/UnitContext";
// import { useTenantContext } from "./Contexts/TenantContext";
import { useTenantContext } from "./components/Tenants/TenantContext.js";
import { useReportsData } from "./Contexts/ReportsContext.js";
// import { useReportsData } from "./Contexts/ReportsDataContext";

import { usePayments } from "./Contexts/PaymentsContext";
import Lottie from "lottie-react";
import loaderAnimation from "./assets/animations/loader.json";

function Dashboard() {
  const navigate = useNavigate();
  const { jwt, user, isLoadingSession } = useAuth();

  // Use contexts to get data and loading states
  const { isLoadingAllUnits } = useUnits();
  const { isLoadingTenants } = useTenantContext();
  const { isLoading: isLoadingReports } = useReportsData();
  const { isLoading: isLoadingPayments, hasInitiallyLoaded: paymentsLoaded } =
    usePayments();

  // Track if initial data load is complete
  const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false);

  // Determine if any data is still loading
  const isAnyDataLoading =
    isLoadingSession ||
    isLoadingAllUnits ||
    isLoadingTenants ||
    isLoadingReports ||
    (isLoadingPayments && !paymentsLoaded);

  useEffect(() => {
    // Once all initial loads are complete, set the flag
    if (!isAnyDataLoading && !isInitialLoadComplete) {
      setIsInitialLoadComplete(true);
    }
  }, [isAnyDataLoading, isInitialLoadComplete]);

  // Show single loader for initial load
  if (!isInitialLoadComplete && isAnyDataLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          style={{ width: 150, height: 150 }}
        />
      </div>
    );
  }

  console.log("Dashboard user:-", user);

  const handleRecentPaymentClick = () => {
    navigate("/dashboard/payments");
  };

  const handleViewAllUpcomingRent = () => {
    navigate("/dashboard/reports");
  };

  const handleViewAllProperties = () => {
    navigate("/dashboard/my-properties");
  };

  const handleTenantsClick = () => {
    navigate("/dashboard/tenants-list");
  };

  return (
    <div className="space-y-3 min-h-screen">
      {/* <h1 className="text-2xl font-bold text-gray-800">Home</h1> */}

      {/* Section 1: Rent Income (Full Width) */}
      <section className="bg-white rounded-lg shadow-md p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-700">Rent Income</h2>
          <button
            className="text-sm text-blue-600 hover:text-blue-800 font-medium"
            onClick={() => navigate("/dashboard/collections-building-wise")}
          >
            View Insights
          </button>
        </div>
        <RentIncome />
      </section>

      {/* Section 2: Recent Payments (Full Width) */}
      <section className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-700">
            Recent Payments
          </h2>
          <button
            className="text-sm text-blue-600 hover:text-blue-800 font-medium"
            onClick={handleRecentPaymentClick}
          >
            View All
          </button>
        </div>
        <div className="p-4">
          <CustomComponent
            displayAll={false}
            showDownloadButton={false}
            limitRows={true}
          />
        </div>
      </section>

      {/* Section 3: Upcoming Rent & Tenants (Two Columns) */}
      <section className="flex flex-col md:flex-row gap-6">
        {/* Left Column: Upcoming Rent (Wider) */}
        <div className="w-full md:w-2/3 bg-white rounded-lg shadow-md p-4">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold text-gray-700">
              Upcoming Rent
            </h2>
            <button
              className="text-sm text-blue-600 hover:text-blue-800 font-medium"
              onClick={handleViewAllUpcomingRent}
            >
              View All
            </button>
          </div>
          <UpcomingRent />
        </div>

        {/* Right Column: Tenants (Narrower) */}
        <div className="w-full md:w-1/3 bg-white rounded-lg shadow-md p-4">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold text-gray-700">Tenants</h2>
            <button
              className="text-sm text-blue-600 hover:text-blue-800 font-medium"
              onClick={handleTenantsClick}
            >
              View All
            </button>
          </div>
          <Tenants />
        </div>
      </section>

      {/* Section 4: Properties (Full Width) */}
      <section className="bg-white rounded-lg shadow-md p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-700">Properties</h2>
          <button
            className="text-sm text-blue-600 hover:text-blue-800 font-medium"
            onClick={handleViewAllProperties}
          >
            View All
          </button>
        </div>
        <Properties />
      </section>
    </div>
  );
}

export default Dashboard;
